module.exports = "/public/images/7ff43fb8e3f8fc1ed05d8f6ddfe01f99.png";